import { alpha, darken } from "@mui/system";

const styles = (theme) => ({
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: 500,
    bgcolor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.background.modal || theme.palette.background.paper, 0.95)
        : alpha(theme.palette.background.paper, 0.95),
    backdropFilter: "blur(10px)",
    borderRadius: 2,
    boxShadow: 24,
    p: 3,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme.palette.divider}`,
    pb: 1,
    mb: 1,
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontWeight: "bold",
    fontSize: "1.1rem",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  cardLabel: {
    fontSize: "0.85rem",
    fontWeight: "bold",
    color: theme.palette.text.secondary,
  },
  cardContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor:
      theme.palette.background.wallpaper,
    padding: "8px 12px",
    borderRadius: 1,
    border: `1px solid ${theme.palette.divider}`,
    cursor: "pointer",
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.background.wallpaper, 0.6)
          : darken(theme.palette.background.wallpaper, 0.05),
    },
  },
  cardValue: {
    fontFamily: "monospace",
    fontSize: "0.95rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  iconButton: {
    padding: "4px",
    marginLeft: "8px",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px 0",
    textAlign: "center",
    color: theme.palette.text.secondary,
  }
});

export default styles;
